import { connect } from 'react-redux';
import { compose, withHandlers, withState, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';

import withNewDesignStyles from '../../../../../common/hoc/withNewDesignStyles';
import {
  getMetricsDefinitions,
  getReportDefinitionById,
} from '../../selectors';
import {
  getAvailableMetrics,
  getSelectedMetrics,
  handleDeselectAll,
  handleSelectAll,
  handleSelectMetric,
  handleDeselectMetric,
  handleMetricDrop,
} from './utils';

const CustomReportMetricsContainer = compose(
  withNewDesignStyles,
  withRouter,
  connect((state, ownProps) => ({
    item: getReportDefinitionById(state, ownProps.params.id),
    metricsDefinitions: getMetricsDefinitions(state),
  })),
  withState(
    'availableMetrics',
    'setAvailableMetrics',
    ({ metricsDefinitions, item }) => getAvailableMetrics(metricsDefinitions, item)
  ),
  withState(
    'selectedMetrics',
    'setSelectedMetrics',
    ({ metricsDefinitions, item }) => getSelectedMetrics(metricsDefinitions, item)
  ),
  withHandlers({
    toggleMetricBreakdown: props => metricId => () => {
      props.setSelectedMetrics(props.selectedMetrics.map(
        metric =>
          (metric.metricId === metricId ? { ...metric, breakdownSelected: !metric.breakdownSelected } : metric)
      ));
    },
    onSelectMetric: props => metricId => () => handleSelectMetric(props, metricId),
    onDeselectMetric: props => metricId => () => handleDeselectMetric(props, metricId),
    onMetricDrop: props => result => handleMetricDrop(props, result),
    onSelectAll: props => () => handleSelectAll(props),
    onDeselectAll: props => () => handleDeselectAll(props),
  }),
  withPropsOnChange(['selectedMetrics'], (props) => {
    props.onReportMetricsChange(props.selectedMetrics);
  }),
);

export default CustomReportMetricsContainer;
